import styled from 'styled-components';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import DEVICES from '../../../common/styles/devices';
type NFCustomInfoCarouselCardStyleProps = {
  padding?: string;
  borderColor?: string;
  borderRadius?: number;
  showSeparator?: boolean;
  showCta?: boolean;
};

export const NFCustomInfoCarouselCardContainer = styled.div<NFCustomInfoCarouselCardStyleProps>`
  cursor: pointer;
  background-color: ${COLORS.white};
  width: 450px;
  padding: 24px 16px;
  display: grid;
  grid-template-columns: ${({ showCta }) => `2fr 10fr ${showCta ? '4fr' : '1fr'}`};
  align-items: center;
  gap: 8px;
  border: ${({ borderColor }) => `1px solid ${borderColor ?? COLORS.borderGrey}`};
  border-radius: ${({ borderRadius }) => borderRadius ?? 5}px;
  .text-container {
    display: flex;
    padding: ${({ padding }) => padding ?? 'auto'};
    flex-direction: column;
    border-left: ${({ showSeparator }) =>
      showSeparator ? `1px solid ${COLORS.borderGrey}` : 'none'};

    .__title {
      font-size: 16px;
      font-family: ${FONT_FAMILY.hellix.bold};
      line-height: 26px;
    }
    .__description {
      font-size: 14px;
      line-height: 18px;
    }
  }
  .cta-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    img {
      width: fit-content;
    }
    .cta {
      flex: 3;
      font-family: ${FONT_FAMILY.hellix.bold};
      color: ${COLORS.darkBlue};
      line-height: 24px;
      font-size: 16px;
    }
  }

  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
